import { Outlet } from "react-router";
import { SimpleDialogContainer } from "react-simple-dialogs";

export const DefaultLayout = () => {
  return (
    <>
      <Outlet />
      <SimpleDialogContainer />
    </>
  );
};
